export default __webpack_public_path__ + "static/media/dashboard 1.1e3165ce.svg";